import { render, staticRenderFns } from "./ReferAFriend.vue?vue&type=template&id=8f974130&"
import script from "./ReferAFriend.vue?vue&type=script&lang=js&"
export * from "./ReferAFriend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports